import React from "react";
import ReactDOM from "react-dom/client";
import WeinkellerApp from "./WeinkellerApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<WeinkellerApp />);